import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/apps/custom-made/src/app/configurator/hide-cookie-button.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientI18NProvider"] */ "/home/runner/work/monorepo/monorepo/packages/utility/i18n/src/client.tsx");
